import EditPolicyPageV2 from "pages/spin/shared/EditPolicyPageV2";

export default EditPolicyPageV2;
